module.exports = __webpack_public_path__ + "img/spatialDB.750f986f.png";